import React from 'react';
import { motion } from 'framer-motion';
import type { LucideIcon } from 'lucide-react';

interface StatCardProps {
  title: string;
  value: string;
  icon: LucideIcon;
  isLoading?: boolean;
}

export function StatCard({ title, value, icon: Icon, isLoading = false }: StatCardProps) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      whileHover={{
        scale: 1.02,
        transition: { duration: 0.2 }
      }}
      className="relative overflow-hidden rounded-xl bg-gradient-to-br from-[#0054fa] via-[#002787] to-[#030a21] border border-blue-500/20 group"
    >
      <motion.div 
        className="absolute inset-0 bg-gradient-to-r from-transparent via-blue-500/5 to-transparent"
        initial={{ x: '-100%' }}
        whileHover={{ x: '100%' }}
        transition={{ duration: 0.8, ease: 'easeInOut' }}
      />
      <div className="relative p-4">
        <div className="flex items-center justify-between">
          <div className="space-y-1">
            <p className="text-gray-400 text-xs">{title}</p>
            {isLoading ? (
              <div className="h-6 w-24 bg-gray-700/50 animate-pulse rounded-lg" />
            ) : (
              <p className="text-lg font-bold text-white tracking-tight">
                {value}
              </p>
            )}
          </div>
          <div className="bg-blue-500/10 p-2 rounded-lg group-hover:bg-blue-500/20 transition-colors">
            <Icon className="w-5 h-5 text-blue-400" />
          </div>
        </div>
      </div>
    </motion.div>
  );
}